import { VOUCHER_EMPLOYEES_ENDPOINTS } from "@/features/vouchers";
import type {
  VoucherEmployeesResponse,
  SortVoucherEmployeeRequestPayload,
  ResetVoucherEmployeeOrderRequestPayload,
} from "@/features/vouchers/types/voucherEmployee.type";
import { fetcher } from "@/shared/lib/fetcher.client";

export const getVoucherEmployees = async (): Promise<VoucherEmployeesResponse> => {
  const response = await fetcher.get<VoucherEmployeesResponse>(
    VOUCHER_EMPLOYEES_ENDPOINTS.GET_VOUCHER_EMPLOYEES,
    { params: { per_page: 999 } },
  );
  return response.data;
};

export const sortVoucherEmployees = async (payload: SortVoucherEmployeeRequestPayload): Promise<VoucherEmployeesResponse> => {
  const response = await fetcher.put<VoucherEmployeesResponse>(
    VOUCHER_EMPLOYEES_ENDPOINTS.SET_PRIORITY_ORDER,
    payload,
  );
  return response.data;
};

export const resetVoucherEmployeesOrder = async (payload: ResetVoucherEmployeeOrderRequestPayload): Promise<VoucherEmployeesResponse> => {
  const response = await fetcher.put<VoucherEmployeesResponse>(
    VOUCHER_EMPLOYEES_ENDPOINTS.RESET_PRIORITY_ORDER,
    payload,
  );
  return response.data;
};
